<template>
  <div class="box5">
    <pageTitle title="过往辅导好评如潮"  titleColor="#313433" />
    <!-- <div class="subject-content">
      <img src="../../../assets/coursePage/design/box5/img01.png"/>
    </div> -->
    <div class="demo-box">
      <vue-seamless-scroll
        :data="list1"
        :class-option="classOption"
        class="seamless-warp"
      >
      <img class="demo" src="../../../assets/coursePage/design/box5/img01.png"/>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
    vueSeamlessScroll

  },
  data() {
    return {
      list1: [
        "0",
        "1",
        "2",
        "3",
      ],
      
    };
  },
  computed: {
    classOption() {
      return {
        direction: 2,
        step: 0.5,
        limitMoveNum: 2,
      };
    },
  },
  methods: {
    
  },
};
</script>

<style lang="less" scoped>
.box5 {
  padding: 80px 0 88px;
  width: 100%;
  background: #F6FBFE;
  .demo-box {
    margin-top: 40px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #1d2129;
  }

  .demo {
    width: 2286px;
margin-right: 24px;
  }
  // .subject-content {
  //  padding:0 28px 16px 28px;
  // overflow-x: auto;
  // overflow-y: hidden;
  // max-width: 1888px;
  // margin-top: 48px ;
  //   img{
  //     width: 2286px;
  //     margin-right: 16px;
  //   }
  // }
 
}
</style>
